import React from 'react';
import Section from './Modular/Section';
import Unit from './Modular/Unit';
import Button from './Button';
import './ProjectList.css';
import type { Project } from './Carousel/CarouselItem';

// interface Project {
//   title: string;
//   link?: string;
//   // Add other fields here if needed
// }

interface ProjectListProps {
  projects: Project[];
}

const ProjectList: React.FC<ProjectListProps> = ({ projects }) => {
  const openNewTab = (url: string | undefined) => {
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  return (
    <div className="project-list">
      {projects.map((project, idx) => (
        <Unit
          key={idx}
          layout="flex"
          background="bg-dark"
          justifyContent="center"
        >
          <Button variant="outline" onClick={() => openNewTab(project.link)}>
            {project.title}
          </Button>
        </Unit>
      ))}
    </div>
  );
};

export default ProjectList;
